import { element } from "prop-types";
import React, { useEffect, useState } from "react";
// import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const PagingView = props => {
    const location = useLocation();
    const [items, setItems] = useState([]);

    /**
     * 페이지 클릭
     * @param {*} page
     */
    const clickNum = page => {
        if (props.reload !== undefined) {
            props.reload(page);
        }
    };

    useEffect(() => {
        let items = [];
        const { nowPage, maxSize, totalPage } = props;

        let start = nowPage - Math.floor(maxSize / 2);
        if (start < 1) start = 1;

        let end = start + maxSize;
        if (end > totalPage) {
            end = totalPage;
            start = end - maxSize;
            if (start < 1) start = 1;
        }

        let prev = nowPage - 1;
        if (prev < 1) prev = 1;

        let next = nowPage + 1;
        if (next > totalPage) next = totalPage;

        for (let number = start; number <= end; number++) {
            const act = number === nowPage ? "on" : "";

            items.push(
                <a href="javascript:;" onClick={e => clickNum(number)} className={act}>
                    {number}
                </a>
            );
        }
        setItems(items);
    }, [props]);

    return (
        <div className="pagination">
            {props.nowPage !== 1 && props.totalPage !== 1 && (
                <a href="javascript:;" className="btn prevAll" onClick={e => clickNum(1)}>
                    제일 이전
                </a>
            )}
            {props.nowPage !== 1 && props.totalPage !== 1 && (
                <a href="javascript:;" className="btn prev" onClick={e => clickNum(props.nowPage - 1)}>
                    이전
                </a>
            )}
            {items}
            {props.nowPage < props.totalPage && (
                <a href="javascript:;" className="btn next" onClick={e => clickNum(props.nowPage + 1)}>
                    다음
                </a>
            )}
            {props.nowPage < props.totalPage && (
                <a href="javascript:;" className="btn nextAll" onClick={e => clickNum(props.totalPage)}>
                    제일 다음
                </a>
            )}
        </div>
    );

    //     <Aux>
    //         <Pagination style={{ float: "left" }}>
    //             <Pagination.First onClick={e => this.clickNum(1)} />
    //             <Pagination.Prev onClick={e => this.clickNum(prev)} />
    //             {items}
    //             <Pagination.Next onClick={e => this.clickNum(next)} />
    //             <Pagination.Last onClick={e => this.clickNum(this.props.totalPage)} />
    //         </Pagination>
    //     </Aux>
    // );

    // return (
    //     <div className="pagination">
    //         <a href="#" className="btn prevAll">
    //             제일 이전
    //         </a>
    //         <a href="#" className="btn prev">
    //             이전
    //         </a>
    //         <a href="#" className="on">
    //             1
    //         </a>
    //         <a href="#">2</a>
    //         <a href="#">3</a>
    //         <a href="#">4</a>
    //         <a href="#">5</a>
    //         <a href="#" className="btn next">
    //             다음
    //         </a>
    //         <a href="#" className="btn nextAll">
    //             제일 다음
    //         </a>
    //     </div>
    // );
};

PagingView.defaultProps = {
    maxSize: 5
};

export default PagingView;
